import { Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { useTranslation } from "react-i18next";
Chart.register(...registerables);
type SentimentGaugeProps = {
  sentiment: any;
  noLabel?: boolean;
  minHeight?: number;
};

export function SentimentGauge(props: SentimentGaugeProps) {
  const { t } = useTranslation(["common", "error", "keyword"]);
  var sum = props.sentiment
    ? props.sentiment["negative"] +
      props.sentiment["neutral"] +
      props.sentiment["positive"]
    : 6;

  const gaugeData = {
    labels: [t("common:negative"), t("common:neutral"), t("common:positive")],
    datasets: [
      {
        label: "Tỉ lệ",
        data: [
          props.sentiment ? props.sentiment["negative"] / sum : 2,
          props.sentiment ? props.sentiment["neutral"] / sum : 2,
          props.sentiment ? props.sentiment["positive"] / sum : 2,
        ],
        backgroundColor: ["#EF4C59", "#81d4fa", "#34E82C"],
        borderColor: ["#EF4C59", "#81d4fa", "#34E82C"],
        circumference: 180,

        cutout: "60%",
        rotation: 270,
      },
    ],
    aspectRatio: 1.5,
  };

  const gaugeOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1.5,
    plugins: {
      legend: {
        position: "bottom" as const,
        display: props.noLabel ? !props.noLabel : true ,
      },
    },
  };

  return (
    <div style={{ width: "100%", minHeight: props.minHeight ? props.minHeight + "vh" : "18vh", margin: "auto", animation: "fadeIn 1s" }}>
      <Doughnut data={gaugeData} options={gaugeOptions} />
    </div>
  );
}
